import { DefaultActions, GridToggles, Search, Separator, Showing, Total, Wrapper } from '@/components/Grid/components/header/Heading';
import { CollapseProvider, DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useLogViewerStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useFilters from './useFilters'

function LogViewerGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
  })

  return <DefaultGrid
    heading={<Wrapper>
      <Search />
      <Separator />
      <GridToggles />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions add={null} />
    </Wrapper>}
  />
}

export default function LogViewerGridLayout() {
  return <GridProvider store={useLogViewerStore()}>
    <CollapseProvider>
      <LogViewerGrid />
    </CollapseProvider>
  </GridProvider>
}
